module.exports = __webpack_public_path__ + "static/media/logo.d3dc044d.png";